var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 13.75L47.2008 38.8127C46.8048 45.216 46.607 48.4178 45.002 50.7198C44.2082 51.8578 43.1867 52.8183 42.0017 53.54C39.6052 55 36.3975 55 29.9817 55C23.5578 55 20.3457 55 17.9476 53.5372C16.762 52.8142 15.74 51.852 14.9467 50.712C13.3422 48.4065 13.1486 45.2002 12.7615 38.788L11.25 13.75",
    stroke: "#DB453C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.75H52.5M40.1393 13.75L38.4328 10.2293C37.299 7.89065 36.732 6.7213 35.7542 5.99203C35.5375 5.83025 35.3078 5.68635 35.0675 5.56175C33.9848 5 32.6853 5 30.0863 5C27.422 5 26.09 5 24.9892 5.5853C24.7452 5.71502 24.5124 5.86475 24.2932 6.03293C23.3041 6.79175 22.7516 8.00387 21.6465 10.4281L20.1323 13.75",
    stroke: "#DB453C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 41.25V26.25",
    stroke: "#DB453C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 41.25V26.25",
    stroke: "#DB453C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDelete);
export default __webpack_public_path__ + "static/media/red-delete.f692eca7a113d714aaa066aa9fc302e7.svg";
export { ForwardRef as ReactComponent };